/** Same production Clerk instance and hosted account pages as sgapp-client.
 * ahead.preview.240.org shares the primary 240.org domain, so it is not the
 * study.240tutoring.com satellite. Development uses its configured test instance.
 */
export function clerkConfiguration(origin: string, pathname = '/') {
  const url = new URL(origin);
  const destination = `${url.origin}${/^\/topics\/[^/]+\/?$/.test(pathname) ? pathname : '/'}`;
  const hosted = url.hostname === 'ahead.preview.240.org';
  return {
    hosted,
    provider: {
      ...(hosted ? {
        signInUrl: 'https://accounts.240.org/sign-in',
        signUpUrl: 'https://accounts.240.org/sign-up',
        allowedRedirectDomains: ['240.org', '240tutoring.com', 'study.240tutoring.com'],
      } : {}),
      signInForceRedirectUrl: destination,
      signUpForceRedirectUrl: destination,
      signInFallbackRedirectUrl: destination,
      signUpFallbackRedirectUrl: destination,
      afterSignOutUrl: `${url.origin}/`,
    },
  };
}
